import React, { Fragment } from 'react';
import { Container, Button } from 'react-bootstrap';
import Header from '../../../components/header';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import ListPlanosMun from '../../../components/educacao/documentos/planomunicipal';


function ListPlanosMunScreen() {
    return (
        <Fragment>
            <Head titulo="Planos Municipais da Educação em Macuco" />
            <Header />
            <Container>
               <ListPlanosMun /><br/><br/>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListPlanosMunScreen;